var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_3",
    "data-name": "Grupo 3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.297,
    height: 47.775,
    viewBox: "0 0 35.297 47.775",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12",
    "data-name": "Trazado 12",
    d: "M65.728,0A17.668,17.668,0,0,0,48.08,17.648a20.362,20.362,0,0,0,1.5,6.795,28.461,28.461,0,0,0,2.04,3.815l12.1,18.335a2.3,2.3,0,0,0,4.022,0l12.1-18.336a28.342,28.342,0,0,0,2.04-3.815,20.357,20.357,0,0,0,1.5-6.795A17.668,17.668,0,0,0,65.728,0ZM79.966,23.637a26.077,26.077,0,0,1-1.859,3.478l-12.1,18.336c-.239.362-.315.362-.553,0l-12.1-18.336a26.09,26.09,0,0,1-1.859-3.479,18.483,18.483,0,0,1-1.335-5.988,15.572,15.572,0,0,1,31.144,0A18.5,18.5,0,0,1,79.966,23.637Z",
    transform: "translate(-48.08)",
    fill: "#252429"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13",
    "data-name": "Trazado 13",
    d: "M121.423,64.008a9.343,9.343,0,1,0,9.343,9.343A9.354,9.354,0,0,0,121.423,64.008Zm0,16.61a7.267,7.267,0,1,1,7.267-7.267A7.276,7.276,0,0,1,121.423,80.618Z",
    transform: "translate(-103.775 -55.702)",
    fill: "#252429"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.7ef4dc199fe71264a7f2b8f940d41e88.svg";
export { ForwardRef as ReactComponent };